import React from 'react';
export const LegendRiskLowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={22}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="11" r="8" fill="#15A46E" />
  </svg>
);
